export { default } from './DidNotFind';



// WEBPACK FOOTER //
// ./app/components/search/DidNotFind/index.js